import { LanguageKeys } from '#/@types/translate'

const en: LanguageKeys = {
    '2nd': '2nd',
    '3rd': '3rd',
    '403_fallback_message': 'You do not have permission to access this page. If you believe this is an error, please contact technical support.',
    '403_fallback_title': 'Unauthorized Access',
    '404_fallback_message': 'we could not find the page you are looking for.',
    '404_fallback_title': 'page not found!',
    '429_fallback_message': 'It appears that you are navigating too quickly between screens. To ensure the security of your account and maintain the quality of your experience, we ask that you wait a moment before continuing.',
    '429_fallback_title': 'calm down... breathe!',
    '500_fallback_title': 'sorry, something goes wrong!',
    'abortion': 'abortion',
    'accept': 'accept',
    'access': 'access',
    'access_farm_ccoms': 'Access farm C-Coms',
    'access_item': 'access {item}',
    'access_management': 'access management',
    'accesses': 'access',
    'account': 'account',
    'account_plural': 'accounts',
    'accumulated': 'accumulated',
    'accumulated_behavior': 'accumulated behavior',
    'action_completed': 'action completed successfully!',
    'activate': 'activate',
    'active_contracts': 'active contracts',
    'active_female_plural': 'active',
    'active_female_singular': 'active',
    'active_male': 'active',
    'activity': 'activity',
    'actual_batch': 'current group',
    'add_condition': 'add condition',
    'add_group': 'add group',
    'add_item': 'add {item}',
    'add_new_option': 'create new option {item}',
    'add_permissions_to_page': 'add permissions to page',
    'add_permissions_to_roles': 'add permissions to roles',
    'add_to_another_protocol': 'add to another protocol',
    'add-to-an-existing-protocol': 'add to an existing protocol',
    'additional_info': 'additional information',
    'address': 'address',
    'adjustments': 'adjustments',
    'age_at_first_calving': 'age at first calving',
    'ai': 'AI',
    'AI': 'AI',
    'ai_apresentation_description': 'The more specific the question is, the better I will be able to answer you',
    'ai_apresentation_title': 'How can I help you today?',
    'ai-hormone-implanted': 'HI-FTAI',
    'aimer_cameras': 'Aimer cameras',
    'aimer_cameras_overview':
        "The Aimer integration connects camera monitoring data to CowMed, making it possible to follow the feeding behavior of the batches. The cameras continuously analyze the feed bunk and send indicators that help identify feed availability, occupancy and management needs.\n\nTo learn how to get this feature on your farm, contact CowMed's sales consultants.\n\n### How it works\n\n1. To use the integration, Aimer's camera monitoring service must be installed and operational on the farm. You can hire the service through our sales team.\n2. After installation, request the integration activation from Aimer's technicians or from CowMed's consultant team.\n3. With the integration active, Aimer batches are linked to the corresponding batches registered in CowMed.\n4. After setup, the indicators and alerts generated by the cameras are displayed in the farm's Nutrition context.\n\n### Available data\n\n- Bunk score\n- Daily empty bunk time\n- Waiting time\n- Push Up need alerts",
    'alert_count': 'alert count',
    'alert_hourly': 'alerts by hour',
    'alert_plural': 'alerts',
    'alert_utilization': 'alert utilization',
    'alerted_plural': 'alerted',
    'all_female': 'all',
    'all_male': 'all',
    'all_markings': 'all markings',
    'analysis': 'analysis',
    'and': 'and',
    'animal': 'animal {item}',
    'animal_behavior': 'animal behavior',
    'animal_condition_today': 'whats the status today?',
    'animal_departure': 'animal departure',
    'animal_discard': 'discard of animals',
    'animal_gender': 'animal gender',
    'animal_in_protocol': 'animal in protocol',
    'animal_lists': 'animal lists',
    'animal_name': 'animal name',
    'animal_plural': 'animals {item}',
    'animals': 'animals',
    'animals_a_protocol': 'animals into a protocol',
    'animals_for_review': 'animals to be reviewed',
    'animals_in_withdrawal': 'animals in withdrawal',
    'animals_into_protocol': 'animals into the protocol',
    'answered_at': 'answered at',
    'api': 'api',
    'application': 'application',
    'applications': 'applications',
    'applied': 'applied',
    'applied_plural': 'applied',
    'apply': 'apply',
    'archive_item': 'archive {item}',
    'archived': 'archived',
    'assign_normal_status_to_animal': 'assign a Normal status to this animal',
    'attach_collar': 'link collar',
    'attach_item': 'link {item}',
    'attach_permissions_to_roles': 'attach permissions to roles',
    'attached_batches': 'attached batches',
    'attached_collar': 'collar linked',
    'attachment': 'link',
    'authorize': 'authorize',
    'auto_filled_data': 'auto fulfilled data',
    'automatically_detected': '{item} automatically detected',
    'available_integrations': 'available integrations',
    'available_plural': 'available',
    'available_singular': 'available',
    'average_birth_weight': 'Average birth weight',
    'average_daily_gain': 'average daily gain',
    'average_data_stack_percentage': 'average data stack pct.',
    'average_DEL': 'average DEL',
    'average_panting': 'average panting {item}',
    'average_rumination': 'average rumination {item}',
    'average_weaning_weight': 'Average weaning weight',
    'b2b_screens': 'B2B screens',
    'b2c_screens': 'B2C screens',
    'back': 'back',
    'back_to_cowmed': 'back to Cowmed',
    'batch': 'group',
    'batch_average_plural': 'batch average',
    'batch_diet': 'batch diet',
    'batch_divergence': 'batch divergence',
    'batch_divergence_alert': 'The location is determined based on the concentration of packets sent by the collars to the antennas. Recent communication failures may affect the displayed location. Always keep the information about animal movements between lots up to date.',
    'batch_monitoring': 'batch monitoring',
    'batch_move_fail': 'failed to move batch',
    'batch_move_success': 'batch moved successfully',
    'batch_plural': 'groups',
    'battery_voltage': 'battery voltage',
    'best_bull_mating': 'Best bull for mating',
    'best_time_for_ai': 'best time for AI/NM',
    'birth': 'birth',
    'birthday': 'birthday',
    'blog_and_news': 'blog and news',
    'blog_and_news_description': 'news and content',
    'body_assessment': 'body assessment',
    'body_score': 'body condition score',
    'boxplot_high': 'maximum',
    'boxplot_low': 'minimum',
    'boxplot_median': 'median',
    'boxplot_q1': 'Q1',
    'boxplot_q3': 'Q3',
    'brazilian_holstein_cattle_association': 'Brazilian Holstein Cattle Association',
    'break': 'break',
    'breathing': 'breathing',
    'breathing_status_changed': 'altered respiratory status',
    'brix': 'brix',
    'browser_guard_benefits': 'Keeping your browser up to date helps ensure more security, better performance and the correct functioning of all available features.',
    'browser_guard_benefits_mac': 'Safari is updated together with macOS, so the update must be done through the system. If you prefer, you can also access the system using another browser, such as Chrome, Edge, Firefox or Opera.',
    'browser_guard_confirm_checkbox': 'I declare that I am aware my browser version is not compatible with the minimum recommended version and that this may cause errors or unexpected behavior.',
    'browser_guard_download_tooltip': 'Go to the {browser} download page',
    'browser_guard_eyebrow': 'Update required',
    'browser_guard_footer': 'Update your browser to the latest version and reload this page. If you prefer, you can also access the system using another browser.',
    'browser_guard_footer_feature': 'To continue, access the system using an up-to-date browser, such as Chrome, Edge, Firefox or Opera.',
    'browser_guard_footer_ios': 'To update, open Settings > General > Software Update and install the latest version available. Then come back to this page and try again.',
    'browser_guard_footer_mac': 'To update, open System Settings > General > Software Update and install the latest version available. Then come back to this page and try again.',
    'browser_guard_installed_version_label': 'Installed version',
    'browser_guard_message': 'We noticed you are using {detectedBrowser}, which is below the minimum supported version ({minimumBrowser}) for this system.',
    'browser_guard_message_feature': 'We noticed you are using {detectedBrowser}, which does not support the features required by this system.',
    'browser_guard_message_ios': 'Your device software is out of date and is not compatible with this page. To keep using the CowMed system, update your iPhone or iPad to {minimumBrowser} or later.',
    'browser_guard_message_mac': 'Safari on your Mac is out of date and is not compatible with this page. To keep using the CowMed system, update macOS to get {minimumBrowser} or later.',
    'browser_guard_proceed_button': 'Proceed',
    'browser_guard_title': 'Your browser needs to be updated',
    'browser_guard_title_feature': 'Your browser is not compatible',
    'browser_guard_title_ios': 'Your iPhone or iPad needs to be updated',
    'browser_guard_title_mac': 'Your Safari needs to be updated',
    'browser_guard_update_ios_tooltip': 'See how to update iOS',
    'browser_guard_update_mac_tooltip': 'See how to update Safari',
    'bull_losses': 'losses per bull',
    'bull_migration': 'Bull migration',
    'bull_or_semen': 'Bull / Semen',
    'bull_or_semen_archive_message': 'The bull / semen is no longer available for use on the farm:\n\n- It can no longer be used as an animal father;\n- It can no longer be used in services;\n- It can no longer be used in matings;\n- Its aliases are removed.\n\nAll history is maintained and can be consulted at any time!',
    'bull_or_semen_migration_message': 'Temporarily, farm records must still be created in the old Bull / Semen list. The new list will only be used after the data is fully migrated to the new structure.',
    'bull_or_semen_remove_warning': 'removing this will erase all past data related with this bull/semen',
    'bunk_score': 'bunk score',
    'c_com': 'C-Com {item}',
    'c_com_communication_status': 'c-com communication status',
    'c_com_details': 'c-com details',
    'c_com_managment': 'antenna management',
    'c_com_map': 'C-Com status map',
    'c_com_plural': 'C-Coms {item}',
    'c_com_primary': 'primary C-Coms',
    'c_com_secondary': 'secondary C-Coms',
    'c_com_status': 'c-com status',
    'c_tech': 'C-Tech {item}',
    'caesarean_surgery': 'caesarean or surgery',
    'calf': 'calf',
    'calf_condition': 'calf condition',
    'calf_plural_female': 'calves',
    'calf_unknown': 'calf',
    'calvin_complication': 'any complication during calving?',
    'calvin_estimate': 'calving estimate',
    'calving': 'calving',
    'calving_dificulty': 'calving difficulty',
    'calving_event': 'calving event',
    'calving_event_plural': 'calving events',
    'calving_interval': 'calving interval',
    'calving_plural': 'calvings',
    'calving_procedure': 'calving procedure',
    'calving_projection': 'calving projection',
    'camera_batches': 'cameras',
    'campaign': 'campaign',
    'campaigns': 'campaigns',
    'cancel': 'cancel',
    'cancel_item': 'cancel {item}',
    'cancellation': 'contract cancellation',
    'cancellation_reason': 'cancellation reason',
    'cancellation_request': 'cancellation request',
    'card_view': 'cards',
    'case': 'case',
    'categories': 'categories',
    'category': 'category',
    'ccom_list': 'ccom list',
    'ccom_map': 'ccom map',
    'CCS_or_CBT': 'SCC / SPC',
    'challenge': 'challenge',
    'challenged_animals': 'challenged animals',
    'change_animal': 'animal swap',
    'change_collar_between_animals': 'swap collar between animals',
    'change_collars': 'change collars',
    'change_cow_comfort_between_points': 'change CowComfort between points',
    'change_group': 'change group',
    'change_group_plural': 'group transfer',
    'change_image': 'change image',
    'change_of_item': 'change {item}',
    'change_password': 'change password',
    'change_password_confirmation': 'an e-mail with instructions to redefine password will be sent to user {userName} ({userEmail}). Confirm action?',
    'change_to_heifer': 'change to heifer',
    'charged': 'charged',
    'charger_active': 'charger',
    'charging': 'charging',
    'chart_type_column': 'change to column chart',
    'chart_type_line': 'change to line chart',
    'chart_type_restore': 'restore chart',
    'chat_deleted_successfully': 'chat deleted successfully!',
    'chat_plural': 'chats',
    'check_all_as_read': 'Mark all as read',
    'check_as_read': 'mark as read',
    'choose_field': 'choose field',
    'city': 'city',
    'clear': 'clear',
    'client': 'client',
    'clinical_opinion': 'clinical opinion',
    'close': 'close',
    'closure_by': 'closure by',
    'collar': '{item} Collar',
    'collar_down_sell': 'down sell',
    'collar_event_received_at': 'C-Com transmission',
    'collar_interval': 'collar interval',
    'collar_link': 'collar link',
    'collar_managment': 'collar management',
    'collar_managment_plural': 'collars management',
    'collar_map': 'collar map report',
    'collar_plural': '{item} collars',
    'collar_status': 'collar status',
    'collar_up_sell': 'up sell',
    'collected_milk': 'collected milk',
    'collection': 'collection',
    'colostration': 'colostration',
    'colostrum_type': 'type of colostrum',
    'column_order': 'column order',
    'comfortable': 'comfortable',
    'comment': 'comment',
    'comment_plural': 'comments',
    'commercial_condition_description': 'commercial condition description',
    'commercial_products': 'commercial products',
    'common_status': 'common status',
    'communication_abbreviation': 'comm.',
    'communications': 'communications',
    'compact': 'compact',
    'company': 'company',
    'company_answers': 'company answers',
    'company_contacts': 'company contacts',
    'company_plural': 'companies',
    'compare_with': 'compare with',
    'complement': 'complement',
    'concentrate': 'concentrate',
    'conception': 'conception',
    'conception_per_DEL': 'conception per DEL',
    'conception_rate': 'conception rate',
    'condition': 'condition',
    'config_item': 'config {item}',
    'configured_by_cowmed_team': 'configured by the CowMed team',
    'confirm_item': 'confirm {item}',
    'confirmation': '{item} confirmation',
    'confirmation_of_item': 'confirmation of {item}',
    'confirmed_at': 'confirmed at',
    'confirmed_by': 'confirmed by',
    'confirmed_plural': 'confirmed',
    'connect': 'connect',
    'connected': 'connected',
    'connected_services': 'connected services',
    'connectivity': 'connectivity',
    'contract': 'contract',
    'contract_address': 'address (contract)',
    'contract_first_payment': 'first payment',
    'contract_plural': 'contracts',
    'contract_start_date': 'contract start date',
    'contract_summary': 'contract summary',
    'contracted_plan': 'contracted plan',
    'cookie_consent': 'We use cookies to evaluate and analyze the use of software resources, with a view to improving them and improving the user experience. By agreeing, you authorize us to collect and use this information. Thanks for the contribution.',
    'coordinates': 'coordinates',
    'copied_text_successfully': 'text copied to the clipboard',
    'copy': 'copy',
    'copy_all': 'copy all',
    'copy_unprocessed': 'copy ids unprocessed',
    'corporate_name': 'company name',
    'correct_item': 'correct {item}',
    'country': 'country',
    'cow_analytics': 'cow analytics',
    'cow_analytics_calving_text': 'Pregnant cows next to calving date, currently in pre-calving stage',
    'cow_analytics_conception_text': "Analysis of farm's services efficiency",
    'cow_analytics_discard_text': 'Discard rate and analysis of discard reasons',
    'cow_analytics_drying_text': 'Pregnant cows next to dry-off date',
    'cow_analytics_gestational_loss_text': 'analyzes embryonic and fetal losses in pregnancy',
    'cow_analytics_health_text': 'Analyze the results of good health practices on the farm ',
    'cow_analytics_heat_monitoring_text': 'Heat detection efficiency and alert utilization on the farm',
    'cow_analytics_heat_return_text': 'Animals near heat return period',
    'cow_analytics_marked_as': 'animals marked as: discard, induction, inapt and protocol',
    'cow_analytics_milk_control_text': "track the herd's milk production and quality",
    'cow_analytics_pre_calving_prediction_text': 'Pregnant cows next to enter pre-calving stage',
    'cow_analytics_pregnancy_diagnosis_text': 'Late cows waiting for pregnancy diagnosis',
    'cow_analytics_rearing_text': 'Evaluate the development of young animals on your farm',
    'cow_analytics_services_text': 'Analysis of services performed on the farm ',
    'cow_analytics_transition_text': 'analyzes and reports regarding the transition period',
    'cow_analytics_wellness_text': "Assess your animals' state of thermal comfort, rest and consumption",
    'cow_baby': 'CowBaby',
    'cow_comfort': 'CowComfort {item}',
    'cow_comfort_managment': 'CowComfort management',
    'cow_connect': 'CowConnect',
    'cow_plural': '{item} cows',
    'cowbaby_expired': 'Baby expired',
    'cowconnect_payment_start': 'contract CowConnect',
    'cowsync': 'cowsync',
    'create_item': 'record {item}',
    'created_at': 'created at',
    'created_by': 'created by',
    'created_item_at': '{item} Created at',
    'critical': 'critical',
    'critical_dim_without_pregnancy': 'Critical dim without pregnancy',
    'crop': 'crop',
    'cross_sell_cowconnect_plan': 'cross sell to CowConnect',
    'cross_sell_monitoring_plan': 'cross sell to CowMed Monitoring',
    'cs': 'CS',
    'ctech_possible_removal_message': 'These collars are linked to animals but have no recorded activity, possibly removed or lost. Check and update the link or contact CowMed support.',
    'ctech_waiting_attachment_message': 'these collars are in perfect working order, but they are installed on an animal that has not yet been registered in the system.',
    'current_farm_entry': 'current farm entry',
    'custom_list': 'custom list',
    'customer_center': 'customer center',
    'customization': 'customization',
    'cycle': 'cycle',
    'cycling_rate': 'cycling rate',
    'cycling_rate_accumulated': 'cycling rate accumulated',
    'daily_behavior_slash_production': 'daily behavior / production',
    'daily_meals': 'daily meals',
    'dashboard': 'dashboard',
    'data': 'data',
    'data_from_date': 'data from {date}',
    'data_interval': 'data interval',
    'data_interval_per_batch': 'data interval per batch',
    'data_not_recognized': 'data not recognized',
    'data_plural': 'data',
    'data_stack_max_percentage': 'max data stack pct.',
    'data_to_be_processed': 'data to be processed',
    'data_update': 'data update',
    'data_view': 'data view',
    'data_view_benchmarking_text': 'Check the performance ranking of farms monitored by Cowmed',
    'data_view_contracts_text': 'operational analysis of accounts and contracts',
    'data_view_contracts_title': 'accounts and contracts',
    'datagrid_actions': 'action',
    'datagrid_config_message': 'the settings defined in this section are applied only locally in your browser. they do not affect data export, serving only to facilitate table visualization.',
    'datagrid_config_title': 'important',
    'datagrid_records_info': 'record {from} to {to} of {total}',
    'datagrid_results_per_page': 'results per page:',
    'datatable_no_records_found': 'record not found',
    'date': 'date',
    'date_after_maximal': 'date should not be after maximal date',
    'date_before_minimal': 'date should not be before minimal date',
    'date_format_long': 'MM/DD/YYYY',
    'date_format_long_timestamped': 'MM/DD/YYYY HH:mm',
    'date_milk_production': 'Date of milk production',
    'date_of_marking': 'date of marking',
    'datepicker_last_days': 'last {days} days',
    'datepicker_previous_month': 'last month',
    'day': 'day',
    'day_monitoring': 'day monitoring',
    'days': 'days',
    'days_open': 'days open',
    'DEA': 'days open',
    'deactivate': 'deactivate',
    'death_method': 'disposal method',
    'default': 'default',
    'default_values': 'default values',
    'DEL': 'days in lactation',
    'DEL_long_text': 'days in lactation',
    'delay_ccom_legend': 'data related to the first hour status',
    'delay_legend': 'color scale according to data transfer delay:',
    'delete_inapt': 'By undoing this marking, the cow is considered fit during the marking period. This record is used to correct marking errors. If you just want to release this cow from today and make it fit, we suggest registering the "uncheck as" event.',
    'delete_inapt_message': 'Are you sure you want to remove the cow tag?',
    'delete_permanently': 'delete permanently',
    'deleted_at': '{item} deleted at',
    'delivery_address': 'delivery address',
    'departure_kind': 'type of departure',
    'departure_reason': 'reason of departure',
    'dependent': 'dependent',
    'description': 'description',
    'designed_by': 'designed by',
    'desynchronized': 'desynchronized',
    'detach_collar': 'unlink collar',
    'detach_item': 'unlink {item}',
    'detached_collar': 'unlink collar',
    'details': 'details',
    'detected': 'detected {item}',
    'detected_at': '{item} detected at',
    'detection_method': 'detection method',
    'developer_mode': 'developer mode',
    'developer_mode_description': 'development resources',
    'device_label': 'device',
    'device_list': 'device list',
    'device_renewal': 'device renewal',
    'device_status': 'device status',
    'device_status_plural': 'device status',
    'diagnosed_animals': 'diagnosed animals',
    'diagnostic': 'diagnostic',
    'diagnostic_plural': 'diagnostics',
    'did_the_animal_exhibit_any_abnormal_behavior': 'any anomaly detected?',
    'diet_handling': 'diet handling',
    'diet_initials': 'D',
    'diet_label': 'diet',
    'diet_setup': 'diet setup',
    'difference_between_minimum_maximum': 'diff between min and max index',
    'difficult_assistance': 'difficult (Extra Assistance)',
    'difficult_vet_care': 'difficult (Veterinary Care)',
    'dim_first_service_dispersion': 'dispersion on 1st service',
    'dim_losses': 'losses by dim',
    'DIM_on_first_service': 'DIM on 1st service',
    'DIM_on_first_service_help_message': "Shows the days in lactation at the time of the animals' first service and conception efficiency. Only considers services performed after 30 days, ensuring the minimum time required for pregnancy diagnosis.",
    'discard': 'discard',
    'discard_collar': 'discard collar',
    'discard_cow_comfort': 'discard CowComfort',
    'discard_moment': 'discard moment',
    'discard_out': 'discard / out',
    'discard_plural': 'discards',
    'discard_rate': 'discard rate',
    'discard_reason': 'discard reason',
    'discard_register': 'discard/sell/deletion register',
    'discard_total': 'total discard',
    'discarded_animals': 'discarded animals',
    'discarded_or_deleted': '{item} discarded/deleted',
    'disconnect': 'disconnect',
    'disconnect_integration_alert': 'the integration settings will be deleted and must be entered again to connect.',
    'disconnected': 'disconnected',
    'disconnected_singular': 'disconnected',
    'dnd_drag_animals_to_batch': 'to add animals to a batch, drag them to this column',
    'dnd_drag_to_column': 'drag items to this column',
    'dnd_drag_to_define_order': 'drag fields to define the display order in the table',
    'do_you_really_want_to_item': 'do you really want to {item} {id}?',
    'do_you_really_want_to_reverse_archive_item': 'Are you sure you want to undo the archiving of the {item} {id}?',
    'do_you_really_want_to_revert_this_application': 'are you sure you want to revert this application?',
    'document_date_format': 'document date format',
    'donor': 'donor',
    'donor_plural': 'donors',
    'download': 'download',
    'download_app': 'download the Cowmed app',
    'download_file': 'download file',
    'download_pdf': 'download pdf file',
    'download_png': 'download png image',
    'download_results': 'download results',
    'download_spreadsheet': 'download spreadsheet {item}',
    'download_template_spreadsheet': 'download the template sheet',
    'download_xls': 'download XLS file',
    'dry': 'dry',
    'dry_event_plural': 'dry events',
    'dry_reason': 'dry-off reason',
    'drying': 'dry-off',
    'drying_projection': 'dry-off projection',
    'DTR_initials': 'TCR',
    'DUI_long_text': 'days last insemination',
    'duplicate_item': 'duplicate {item}',
    'duplicate_role': 'duplicate role',
    'easy_unassisted': 'easy (Unassisted)',
    'edit_farm_bull_link': 'edit farm bull link',
    'edit_personal_info': 'edit personal information',
    'ein': 'EIN',
    'eligible_cow_plural': 'eligible cows',
    'email': 'e-mail',
    'embryo_transfer': 'embryo transfer',
    'embryo_type': 'embryo type',
    'empty': 'open',
    'empty_animal': 'open animal',
    'empty_farm_profile_msg': "Oops! Looks like you haven't registered your profile for this farm yet!",
    'empty_list': 'empty list',
    'empty_male': 'open',
    'empty_time': 'empty time',
    'empty-post-delivery': 'open VWP',
    'end_date': 'end date',
    'end_of_item_withdrawal': 'end of {item} withdrawal period',
    'end_of_messages': 'end of messages',
    'engagement': 'engagement',
    'environmental_comfort': 'environmental comfort analysis',
    'error_500': 'An error has occurred. Sorry for the inconvenience. If the problem persists, please email software@cowmed.com indicating what action was taken to cause this error.',
    'error_deleting_chat': 'error deleting chat',
    'error_maintenance': 'error/maintenance',
    'error_plural': 'errors',
    'error_sending_feedback': 'An error occurred sending your feedback!',
    'ET': 'ET',
    'et-hormone-implanted': 'HI-FTET',
    'evaluation_date': 'evaluation date',
    'event': 'event',
    'event_of_plural': '{item} events',
    'event_plural': 'events',
    'exit_fullscreen': 'exit fullscreen',
    'exitFullscreen': 'exit fullscreen',
    'export': 'export {item}',
    'export_data': 'export data',
    'exportable': 'exportable',
    'exportation': 'exportation',
    'exporting': 'exporting...',
    'exports': 'exports',
    'extra_modules': 'extra modules',
    'failed': 'failed',
    'farm': 'farm',
    'farm_account_plural': 'farm accounts',
    'farm_address': 'farm address',
    'farm_answers': 'farm answers',
    'farm_code': 'farm ID',
    'farm_contract_plural': 'farm contracts',
    'farm_database': 'farm database',
    'farm_distribution': 'farm distribution',
    'farm_list': 'list farms',
    'farm_list_description': 'farms available to you',
    'farm_management': 'farm management',
    'farm_name': 'farm name',
    'farm_OKR': 'OKR',
    'farm_plural': 'farms',
    'farm_profile': 'Farm profile',
    'farm_revision': 'farm revision',
    'farm_settings': 'farm settings',
    'farm_settings_description': 'network, OKR, users and more',
    'farms_without_portfolio': 'farms without portfolio',
    'fat_percentage': 'fat (%)',
    'feed': 'feed',
    'female': 'female',
    'fidelity': 'fidelity',
    'field': 'field',
    'file': 'file',
    'files': 'files',
    'fill_all_required_fields': 'fill all the required fields',
    'filter': 'filter',
    'final_value': 'final value',
    'financing_modality': 'financing modality',
    'find_by_item': 'search for {item}',
    'find_item': 'locate {item}',
    'finish': 'finish',
    'finished_at': 'finished at',
    'fixed': 'fixed',
    'foetus': 'sexing',
    'for_discard': 'for discard',
    'for_induction_lactation': 'for lactation induction',
    'for_protocol': 'for protocol',
    'forecast_return': 'forecast return',
    'form_with_errors': 'Oops! We found some errors in the form. Please correct the highlighted fields to proceed with the registration.',
    'formbuilder_error_fetching_data_message': "We couldn't load the form at the moment. Please try again in a few moments. If the problem persists, contact our support team so we can help resolve it as quickly as possible.",
    'formbuilder_error_fetching_data_title': 'Error loading form',
    'full': 'full',
    'full_screen': 'view in full screen',
    'fullscreen': 'view in full screen',
    'gender': 'gender',
    'general': 'general',
    'general_farm': 'general farm',
    'general_herd': 'general herd',
    'general_info_plural': 'general informations',
    'general_milk_control': 'general milk control',
    'general_production': 'general production',
    'general_spreadsheet': 'general spreadsheet',
    'general_status': 'general status',
    'general_wellness': 'general wellness',
    'gestational_loss': 'gestational losses',
    'global_search': 'Search by: Animal, Group, Collar',
    'global_search_pages_and_farms': 'Search by: Farm, Page',
    'group_item': 'Group {number}',
    'growth_curve': 'growth curve',
    'gynecologic_examination': 'gynecologic exam',
    'handling': 'handling',
    'handling_events': 'management events',
    'handling_register': 'management records',
    'health': 'health',
    'health_alert_plural': 'health alerts',
    'health_event': 'health event',
    'health_event_plural': 'health events',
    'health_protocols': 'health protocols',
    'health_status': 'health status',
    'heat': 'heat',
    'heat_alert': 'heat alert',
    'heat_alert_plural': 'heat alerts',
    'heat_detected': 'heat detected',
    'heat_monitoring': 'heat monitoring',
    'heat_register_12_hours_before': 'record new heat event (12h before insemination)?',
    'heat_return': 'return to heat',
    'heat_strength': 'heat strength',
    'heat_type_iatf': 'FTAI',
    'heifer': 'heifer',
    'help': 'help',
    'help_center': 'help center',
    'help_us_understand_what_happened': 'help us understand what happened',
    'herd': 'herd',
    'herd_and_reproduction': 'herd + reproduction',
    'herd_and_reproduction_and_batches': 'herd + reproduction + groups',
    'herd_and_reproduction_and_milk_control': 'herd + reproduction + milk control',
    'herd_cow_analytics_card_text': 'analyze your herd, evolution and distribution',
    'hexadecimal_key': 'hexadecimal key',
    'hideData': 'hide data table',
    'highcharts_events': 'visualization of events',
    'highcharts_export': 'export charts',
    'hint_register_farm_profile_msg': 'Start registering your profile by clicking on the button below.',
    'historic': 'history',
    'home': 'home',
    'hospital_time': 'hospital time',
    'hour_initials_plural': 'hrs',
    'hourly': 'hour/hour',
    'hourly_monitoring': 'hourly monitoring',
    'hours_over_limit': 'hours over limit',
    'how_to_use': 'how to use',
    'humidity': 'humidity',
    'i_got_it': 'Ok, I got it',
    'ia_cob_te': 'AI/NM/ET',
    'identification': 'identification',
    'ignore_temporarily': 'ignore temporarily',
    'ignore_temporarily_alert_message': 'by marking an animal as "Ignored temporarily", it will be removed from the infirmary list for 12 hours. During this period, if there are changes in status, diagnosis or treatment, the animal will automatically return to the list.',
    'ignore_temporarily_confirm_message': 'are you sure you want to ignore this animal temporarily?',
    'image_load_error': 'Could not load the image',
    'implant_lost_initials': 'PI',
    'import': 'import',
    'import_data': 'import data',
    'import_details': 'import details',
    'import_discards': 'import discards',
    'import_item': 'import {item}',
    'import_will_be_notified': 'Click Import. At the end of processing you will be notified.',
    'imports': 'imports',
    'in_cancellation': 'in cancellation',
    'inactive_female': 'inactive',
    'inactive_male': 'inactive',
    'inactive_time': 'inactive time',
    'inapt_for_reproduction': 'inapt for reproduction',
    'included_products': 'included products',
    'index': 'index {item}',
    'individual_milk_control': 'individual milk control',
    'individual_production': 'individual production',
    'induced_lactation': 'induced lactation',
    'induction': 'induction',
    'inductions_realized': 'inductions realized',
    'ineligible_heifer_plural': 'ineligible heifers',
    'infirmary': 'sick cows',
    'info_short': 'info',
    'information_plural': 'informations',
    'ingredient': 'ingredient',
    'ingredient_management': 'feed ingredient management',
    'initial_value': 'initial value',
    'inseminated': 'bred',
    'inseminated_plural': 'bred',
    'insemination': 'insemination',
    'inseminator': 'inseminator',
    'installed_by': 'installed by',
    'intake_and_panting': 'intake and panting',
    'intake_and_rumination': 'intake and rumination',
    'integrations': 'integrations',
    'integrations_description': 'partners and services connected to the farm',
    'intelligence_parameters': 'intelligence parameters',
    'intensity': 'intensity',
    'interaction': 'interaction',
    'international_register': 'international register',
    'interval': 'interval',
    'interval_between_services': 'interval between services',
    'invalid_date_format': 'invalid date format',
    'invalid_field': 'the field "{item}" is not valid',
    'invalid_image_file': 'the selected file is not an image',
    'invalid_latitude': 'Invalid latitude. It must be between -90 and 90.',
    'invalid_longitude': 'Invalid longitude. Must be between -180 and 180.',
    'inventory': 'inventory',
    'is_operating': 'operating',
    'item_count_plural': '{item} items',
    'item_history': '{item} history',
    'item_index': '{item} index',
    'item_lat_lng_invalid': '{item} has invalid latitude/longitude configuration.',
    'item_limit_of': 'of {max} (limit)',
    'item_limits': 'item limits',
    'item_monitored_plural': 'monitored {item}',
    'item_selected_plural': '{item} selected',
    'item_withdrawal': '{item} withdrawal',
    'lactating_animals': 'lactating animals',
    'lactation': 'lactation',
    'lactation_induction': 'lactation induction',
    'lactation_plural': 'lactations',
    'lactose_percentage': 'Lactose (%)',
    'language': 'language',
    'last_ai': 'last IA',
    'last_calving': 'last calving',
    'last_cloud_sync': 'last cloud sync',
    'last_confirmation': 'last confirmation',
    'last_connection': 'last connection',
    'last_feed': 'last feeding',
    'last_insemination': "When was the cow's last insemination...",
    'last_link': 'last link',
    'last_processed_at': 'last processed at',
    'last_read': 'last reading',
    'last_report': 'last report',
    'last_request': 'last request',
    'last_status': 'last status',
    'last_update': 'last update',
    'late_inseminated': 'late bred',
    'late-inseminated': 'late bred',
    'latest_evaluation': 'latest evaluation',
    'latitude': 'latitude',
    'lead_time_cm': 'lead time CM',
    'leisure': 'idle',
    'less_details': 'less details',
    'limit': 'limit',
    'link_to_farm_bull': 'link to farm bull',
    'linked_to_farm_bull': 'linked to farm bull',
    'list_view': 'list',
    'lists': 'lists',
    'load_more': 'load more',
    'loading': 'loading',
    'loading_animal_info': 'loading animal information',
    'loading_batch_info': 'loading batch information',
    'loading_ccom_info': 'loading CCom information',
    'loading_cenv_info': 'loading cowcomfort information',
    'loading_chart_data': 'loading graph data...',
    'loading_company_info': 'loading company information',
    'loading_ctech_info': 'loading collar information',
    'loading_farm_info': 'loading farm information',
    'loading_import_details': 'loading import details',
    'loading_just_a_moment': 'Just a moment. Loading...',
    'loading_list_info': 'loading list information',
    'loading_permission_farm': 'loading farm permissions',
    'loading_production_info': 'loading production information',
    'loading_protocol_info': 'loading protocol information',
    'loading_semen_info': 'loading bull/semen information',
    'loading_thi_info': 'loading THI information',
    'loading_user_info': 'loading user information',
    'loading_wait_a_moment': 'please wait a moment',
    'location': 'location',
    'location_map': 'location map',
    'logout': 'logout',
    'longitude': 'longitude',
    'loss_rate': 'loss rates',
    'lost_female_plural': 'lost',
    'low': 'low',
    'mac_address': 'MAC',
    'maintenance_plural': 'maintenance',
    'male': 'male',
    'mammary_quarter': 'mammary quarter',
    'manage_account': 'Manage account',
    'manage_account_and_password': 'manage account and passwords',
    'manage_item': 'manage {item}',
    'manage_password_and_access': 'manage your account password and sessions',
    'manage_points': 'manage points',
    'management_system': 'cows management system',
    'manufacturer': 'manufacturer',
    'manufacturer_plural': 'manufacturers',
    'mark': 'mark',
    'mark_as_item': 'mark as {item}',
    'mark_as_not_applied_bulk_warning': 'are you sure you want to mark these as not applied?',
    'mark_as_not_applied_warning': 'are you sure you want to mark this as not applied?',
    'marked_as': 'marked as',
    'marked_as_unfit': 'marked as ineligible for reproduction',
    'marked_for_discard': 'marked for discard',
    'marked_for_induction': 'marked for lactation induction',
    'marked_for_induction_plural': 'marked for induction',
    'marked_for_protocol': 'marked for protocol',
    'marked_for_protocol_plural': 'marked for protocol',
    'marking': 'marking',
    'mastitis': 'mastitis',
    'mastitis_causative_agent': 'causative agent',
    'mastitis_dynamics': 'mastitis dynamics',
    'mastitis_history': 'mastitis history',
    'mastitis_intensity_level': 'intensity level',
    'mating': 'Mating',
    'matrix': 'mother',
    'matrix_plural': 'mothers',
    'meals': 'meals',
    'meat': 'meat',
    'medication': 'medication',
    'mild_to_moderate_stress': 'moderate to light stress',
    'milk': 'milk',
    'milk_control': 'milk control',
    'milk_control_and_batches': 'milk control + groups',
    'milk_production': 'milk production',
    'milk_production_date': 'inform the date of the milk control you wish to import. Only records from this date will be processed.',
    'milking_item': 'milking {item}',
    'minute_initials': 'min',
    'model': 'model',
    'model_protocol': 'protocol model',
    'moderated': 'moderated',
    'module_permissions': 'module permissions',
    'module_plural': 'modules',
    'monitored_plural': 'monitored',
    'monitored_points': 'monitored points',
    'monitoring': 'monitoring',
    'monitoring_activation': 'monitoring activation',
    'monitoring_contract': 'monitoring contract',
    'monitoring_data': 'monitoring data',
    'monitoring_point': 'monitoring point',
    'month': 'month',
    'monthly_losses': 'monthly losses',
    'months_april': 'april',
    'months_august': 'august',
    'months_december': 'december',
    'months_february': 'february',
    'months_january': 'january',
    'months_july': 'july',
    'months_june': 'june',
    'months_march': 'march',
    'months_may': 'may',
    'months_november': 'november',
    'months_october': 'october',
    'months_september': 'september',
    'more': 'Know more',
    'more_animals': '{count} more animals',
    'more_details': 'more details',
    'more_information': 'more information',
    'mortality': 'mortality',
    'most_accessed': 'most accessed',
    'move_collar_to': 'move collar {item} to {location}',
    'move_cow_comfort_to': 'move CowComfort {item} to {location}',
    'move_to': 'move to {location}',
    'moved': 'moved',
    'multiparous': 'multiparous',
    'multiselect_item': 'You have selected {quantity} item from your list (up to {max} items).',
    'multiselect_item_plural': 'You have selected {quantity} items from your list (up to {max} items).',
    'multiselect_register': 'Click the options menu to register multiple events simultaneously.',
    'my_protocols': 'my protocols',
    'n_days': '{days} days',
    'name': 'name',
    'national_register': 'national register',
    'natural_mating': 'natural mating',
    'navel_cure': 'navel cure',
    'negotiated_condition': 'negotiated condition',
    'network': 'network',
    'new_attach': 'new attach',
    'new_chat': 'new chat',
    'new_conversation': 'new conversation',
    'new_item_female': 'new {item}',
    'new_item_female_plural': 'new {item}',
    'new_item_male': 'new {item}',
    'next': 'next',
    'no': 'no',
    'no_active_integrations': 'you have no active integrations',
    'no_available_integrations': 'you have no available integrations',
    'no_collar': 'no collar',
    'no_data': 'no data',
    'no_data_after_hours': 'no data for more than {hours} hours',
    'no_data_between_hours': 'no data from {from} to {to} hours',
    'no_data_to_view': 'no data to view',
    'no_item_limit': 'no item limit',
    'no_leading_zeros_in_day': 'no leading zeros in the day',
    'no_leading_zeros_in_month': 'no leading zeros in the month',
    'no_limit': 'no limit',
    'no_location_registered': 'no location registered',
    'no_messages_to_show': 'no messages to show',
    'no_processed_data': 'no processed data',
    'no_reported_data': 'no reported data',
    'no_results_found': 'no results found.',
    'no_service': 'no service',
    'normal': 'normal',
    'normalize_item': 'normalize {item}',
    'not_applied': 'not applied',
    'not_applied_plural': 'not applied',
    'not_moved': 'not moved',
    'not_release': 'not release',
    'note': 'note',
    'note_plural': 'notes',
    'notification_plural': 'notifications',
    'notification_settings_description': 'configure how you receive notifications',
    'nps': 'nps',
    'nps_reason_text': 'what motivated you to give this grade?',
    'nps_score_text': 'on a scale of 0 to 10, how much would you recommend CowMed?',
    'nps_subtitle': 'we always want to guarantee the best experience for you!',
    'nps_title': 'vic wants to know what you think!',
    'number': 'number',
    'number_of_services': 'number of services',
    'nutrition': 'nutrition',
    'nutrition_and_intake': 'nutrition and intake',
    'observation': 'observation',
    'of_day': 'of the day',
    'of_week': 'of the last 7 days',
    'offline': 'offline',
    'op_between': 'between',
    'op_equal': 'equal to',
    'op_greater': 'greater than',
    'op_less': 'less than',
    'op_not_equal': 'not equal to',
    'open_animal_plural': 'open animals',
    'open_apt_heifers': 'open at 15 months',
    'open_c_com_managment': 'Open antenna management',
    'operational': 'operational',
    'operational_status': 'operational status',
    'operator': 'operator',
    'opportunities': 'opportunities',
    'option': 'option',
    'option_plural': 'options',
    'optional': 'optional',
    'or': 'or',
    'order_date': 'order date',
    'ordering': 'ordering',
    'other': 'other',
    'other_information': 'other information',
    'other_software': 'Other Software',
    'others': 'others',
    'outdated_version_warning': 'you are using an outdated version of COWMED. To ensure the system works correctly and avoid errors or inconsistencies, the page will automatically reload in {seconds} seconds.',
    'overall_average': 'overall average',
    'overview': 'overview',
    'owner_name': 'owner name',
    'panting': 'panting',
    'panting_hours': 'panting hours',
    'password': 'password',
    'per_hour': 'per hour',
    'per_item': 'per {item}',
    'performed': 'performed',
    'performed_female': 'performed',
    'performeds_female': 'performeds',
    'permission': 'permission',
    'permission_plural': 'permissions',
    'permissions_list': 'permissions list',
    'phone_number': 'phone',
    'photo': 'photo',
    'please_try_again_contact_support': 'Please try again. If the problem persists, contact support.',
    'point': 'point',
    'points': 'points',
    'portfolio': 'portfolio',
    'portfolio_farms': 'portfolio farms',
    'possible_removal': 'possible removal',
    'power_failure': 'power failure',
    'ppi': 'PPI',
    'ppi_animal': 'animal PPI',
    'ppi_herd': 'PPI herd',
    'pre_calving': 'close-up',
    'pre_calving_event': 'close-up event',
    'pre_calving_event_plural': 'close-up events',
    'prediction_of': '{item} prediction',
    'predominant_breed': 'predominant breed',
    'pregnancy_diagnosis': 'pregnancy diagnosis',
    'pregnancy_pre_calving': 'pre-calving',
    'pregnancy_rate': 'pregnancy rate',
    'pregnant': 'pregnant',
    'pregnant-dry': 'dry pregnancy',
    'pregnant-pre-delivery': 'pre-calving',
    'premature': 'premature',
    'previous_clinical_opinion': 'previous clinical opinion',
    'previous_comment': 'previous comment',
    'primary': 'primary',
    'primary_plural': 'primaries',
    'primiparous': 'primiparous',
    'print': 'print',
    'print_chart': 'print chart',
    'printing': 'Generating file to print...',
    'problem_cows': 'Problem cows',
    'processed_at': 'validated at',
    'processed_successfully': 'processed successfully',
    'processed_with_errors': 'processed with errors',
    'processing_information': 'processing your request',
    'production': 'production',
    'production_analysis': 'production analysis',
    'production_details': 'production details',
    'production_register': 'production records',
    'production_slash_rumination': 'production/rumination',
    'production_total': 'total production',
    'productive_ranking': 'productive ranking',
    'profile_and_intake': 'profile and intake',
    'programmed': 'programmed',
    'project': 'project',
    'project_informations': 'project information',
    'project_type': 'project type',
    'projection_lactating_cows': 'projection of lactating cows',
    'projects': 'projects',
    'prostaglandin': 'PG',
    'protein_percentage': 'Protein (%)',
    'protocol': 'protocol',
    'protocol_add_animal': 'add animals to protocol',
    'protocol_details': 'protocol details',
    'protocol_model_subtitle': 'Register here the information for the FTAI, TETF, and PG protocol models.',
    'protocol_plural': 'protocols',
    'protocol_remove_animal': 'remove animals from protocol',
    'protocol_start': 'start of protocol',
    'protocol_subtitle': 'Register here information about the TAI, ET and PG protocols',
    'protocoled_animals': 'protocoled animals',
    'PS': 'ps.',
    'push_up_needed': 'push-up needed',
    'pushing': 'pushing',
    'quantity_supplied': 'quantity supplied',
    'quarter_abbreviation_left-back': 'RL',
    'quarter_abbreviation_left-front': 'FL',
    'quarter_abbreviation_right-back': 'RR',
    'quarter_abbreviation_right-front': 'FR',
    'quarter_description_left-back': 'rear left',
    'quarter_description_left-front': 'front left',
    'quarter_description_right-back': 'rear right',
    'quarter_description_right-front': 'front right',
    'queued': 'queued',
    'queued_at': 'queued at',
    'quick_tip': 'quick tip',
    'rag': 'RAG',
    'rags': 'RAGS',
    'raising_infirmary': 'sick calves',
    'reactivation_cowconnect': 'reactivate CowConnect',
    'reactivation_monitoring': 'reactivate monitoring',
    'read_later': 'read later',
    'real_time': 'real time',
    'rearing_raising': 'rearing & raising',
    'reason_text': 'reason',
    'receiving_packages': 'receiving packages',
    'reception': 'reception',
    'recommendation': 'recommendation',
    'recommended_hour': 'Recommended time expired {item} hour ago',
    'recommended_hour_plural': 'Recommended time expired {item} hours ago',
    'reconnected': 'reconnected',
    'recover_this_register': 'recover this register',
    'recovered': 'recovered',
    'recovered_event': 'recovered event',
    'redirect_timer': 'At {time} {unit} you will be redirected.',
    'redirecting_to_farm': 'redirecting to the farm',
    'regional-station': 'regional station',
    'register': 'register',
    'register_another_swap': 'register another swap',
    'register_item': 'register {item}',
    'register_item_updated_success_male': '{item} registered/updated successfully',
    'register_more_details': 'i want to register more details',
    'register_new_animal': 'register new animal',
    'registered_at_date': 'registered at {date}',
    'registered_by': 'registered by',
    'registered_losses': 'registered losses',
    'registration_data': 'registration data',
    'registration_of': '{item} register',
    'reinstate_contract': 'contract reactivation',
    'reject': 'reject',
    'related_batches': 'related batches',
    'relationship': 'relationship',
    'relationship_type': 'Relationship type',
    'release': 'release',
    'release_notes': 'release notes',
    'release_to_reproduction': 'release to reproduction',
    'reload': 'reload',
    'remove_condition': 'remove condition',
    'remove_group': 'remove group',
    'remove_item': 'remove {item}',
    'remove_message': 'remove message',
    'remove_rag': 'do you really want to remove RAG {item}?',
    'remove_row': 'remove row',
    'remove_tokenized_animal': 'remove the animal from the list of tokenized animals',
    'removed_animals': 'removed animals',
    'removed_female': 'removed',
    'renewal_cowconnect': 'CowConnect Renewal',
    'renewal_monitoring': 'Monitoring Renewal',
    'renewals': 'renewals',
    'replace': 'exchange',
    'replace_item': 'replace {item}',
    'replace_records': 'correct records',
    'replacement_rate': 'replacement rate',
    'replacement_request': 'replacement request',
    'replay_later': 'reply later',
    'report_cause_of_error': 'In order to help our team, report what did you do to cause this error.',
    'reported_at': 'reported at',
    'reproduction': 'reproduction',
    'reproduction_event': 'reproduction event',
    'reproduction_event_plural': 'reproduction events',
    'reproduction_event_this': 'this reproduction event',
    'reproduction_restriction': 'reproduction restriction',
    'reproduction_status': 'reproduction status',
    'reproductive_distribution': 'reproductive distribution',
    'reproductive_evaluation': 'Reproductive evaluation',
    'reproductive_event_history': 'reproductive event history',
    'reproductive_management': 'reproductive management',
    'reproductive_protocol': 'reproductive protocol',
    'reproductive_protocols': 'reproductive protocols',
    'required_field': 'required field',
    'reset_config': 'reset configuration',
    'reset_item': 'reset {item}',
    'reset_zoom': 'reset zoom',
    'resources': 'resources',
    'response_error': 'ooops!',
    'response_info': 'info!',
    'response_percentage': 'response percentage',
    'response_success': 'success!',
    'response_warning': 'attention!',
    'responsible': 'responsible',
    'restart_time': 'restart time',
    'restore': 'restore',
    'restore_event': 'restore event',
    'restore_item': 'restore {item}',
    'restore_this': 'restore this {item}',
    'results': 'results',
    'results_analysis': 'analysis of results',
    'return_heats': 'return heats',
    'revert_ignore_temporarily': 'revert ignore temporarily',
    'revert_ignore_temporarily_confirm_message': 'are you sure you want to revert "Ignore temporarily" for this animal?',
    'revert_item': 'revert {item}',
    'revision': 'revision',
    'role': 'role',
    'role_permissions': 'role permissions',
    'role_plural': 'roles',
    'root': 'root',
    'row': 'row',
    'row_index': 'index',
    'rumination': 'rumination',
    'rumination_max_index': 'max rumination index',
    'rumination_min_index': 'min rumination index',
    'rumination_profile': 'rumination profile',
    'sample': 'sample',
    'sanitary-protocol': 'health protocol',
    'save': 'save',
    'save_config': 'save configuration',
    'save_file_in_format': 'save the file in {format} format',
    'SBC_network_interface': 'SBC network interface',
    'SBC_status': 'SBC status',
    'SBC_version': 'SBC version',
    'SBC_voltage': 'SBC voltage',
    'SCC_x1000': 'SCC (x1000)',
    'schedule_protocol': 'protocol programming',
    'scheduleds_female': 'scheduleds',
    'search': 'search',
    'search_back_to_all': 'back to all categories',
    'search_filter_all': 'all',
    'search_filter_pages': 'pages',
    'search_in_the_menu': 'menu search...',
    'search_no_recent_example': 'try searching for **animals**, **groups**, **collars** or **pages**',
    'search_no_recent_title': 'nothing here yet',
    'search_recent': 'recent',
    'search_shortcut_navigate': 'navigate',
    'search_shortcut_open': 'open',
    'search_system_accesses_description': 'farm list',
    'secondary': 'secondary',
    'secondary_plural': 'secondary',
    'security': 'security',
    'see_again': 'see again',
    'see_all': 'see all',
    'see_item': 'see {item}',
    'see_less': 'see less',
    'see_list_of_item': 'see list of {item}',
    'seed': 'seed',
    'select_all': 'select all',
    'select_date_of_milk_production_instruction': 'Select the date of milk production of the file to be imported.',
    'select_exported_file': 'Select the exported software file {software}.',
    'select_exported_file_dairyplan': 'select the exported software file {software} and fill in the column names as directed by the Customer Success team (Brinco, Nome, L, Pai, Mae, DtNasc, Reg, Parto, IA, Hora, TouroIA, Stat, DtDg, DtSec, Prod).',
    'select_interval': 'select an interval',
    'select_one_item_female': 'select one {item}',
    'select_one_item_male': 'select one {item}',
    'select_option_and_all_related_options': 'Selecting this option will automatically select all related options',
    'select_spreadsheet_type': 'select the spreadsheet type',
    'selected_data': 'selected data',
    'selected_maximum_number_of_items_allowed': 'You have reached the maximum limit of {max} items allowed.',
    'selection_summary': 'Selection summary',
    'selection_summary_subtitle': 'View and validate the criteria applied to your filters.',
    'semen_type': 'semen type',
    'send': 'send',
    'sending': 'sending...',
    'serial': 'serial number',
    'serum_proteins': 'serum proteins',
    'service': 'service',
    'service_at': 'Service in',
    'service_cycles': 'service cycles',
    'service_plural': 'services',
    'service_rate': 'service rate',
    'service_type': 'service type',
    'services_monthly': 'monthly services',
    'services_weekly': 'weekly services',
    'set_as_main': 'set as main',
    'settings': 'settings',
    'SFN_percentage': 'SFN (%)',
    'short_description': 'short description',
    'short_months_apr': 'apr',
    'short_months_aug': 'aug',
    'short_months_dec': 'dec',
    'short_months_feb': 'feb',
    'short_months_jan': 'jan',
    'short_months_jul': 'jul',
    'short_months_jun': 'jun',
    'short_months_mar': 'mar',
    'short_months_may': 'may',
    'short_months_nov': 'nov',
    'short_months_oct': 'oct',
    'short_months_sep': 'sep',
    'shortcuts': 'shortcuts',
    'show_help': 'click to show help',
    'show_item': 'show {item}',
    'showing_quantity_of_total_results': 'showing {quantity} from {total} found results',
    'sign_out_of_account': 'sign out of account',
    'signals_and_symptoms': 'Signs / Symptoms',
    'signed_contracts': 'signed contracts',
    'signs': 'signs',
    'site_in_maintenance': "we'll be right back!",
    'site_in_maintenance_text': 'the service is temporarily unavailable. Our team is already working to restore access so you can resume using the system shortly.',
    'skip_item': 'skip {item}',
    'software_download_spreadsheet': 'download the spreadsheet {spreadsheetName} from the software {software}.',
    'software_name': 'CowMed',
    'solid_components': 'solid components',
    'solid_percentage': 'Solids (%)',
    'something_went_wrong': 'something went wrong. Please try again.',
    'son_plural': 'sons',
    'sorry_dont_find_results': "sorry, we couldn't find results for",
    'sort_by': 'sort by',
    'source_review': 'source review',
    'source_voltage': 'source voltage',
    'spacing': 'spacing',
    'spacious': 'spacious',
    'SPC_x1000': 'SPC (x1000)',
    'special_requirements': 'special requirements',
    'specific_configuration': 'specific configuration',
    'stage_losses': 'period losses',
    'start_date': 'start date',
    'start_sync': 'start date (first treatment)',
    'started': 'started',
    'started_at': 'started at',
    'state': 'state',
    'status': 'status',
    'status_normalization': 'status normalization',
    'stillbirth': 'stillbirth',
    'storage': 'storage',
    'strength': 'strength',
    'stress_light': 'light stress',
    'stress_moderate_to_severe': 'moderate to severe stress',
    'stress_severe': 'severe stress',
    'stress_zone': 'stress zone',
    'submit_feedback': 'submit feedback',
    'success': 'finished successfully',
    'success_with_warnings': 'finished with warnings',
    'supply_time': 'supply time',
    'support': 'support',
    'support_notes': 'support notes',
    'suspected_loss': 'suspected loss',
    'suspended_account_message': 'it seems that your account has been suspended, please contact the customer support team and your registration status. See you soon!',
    'suspended_account_title': 'no farm access!',
    'sync_now': 'sync now',
    'sync_now_message': 'the sync with {item} will start now. Do you want to continue?',
    'synchronized': 'synced',
    'system': 'system',
    'system_users': 'system users',
    'table_export_warning': "The size of this table exceeds the print limit. For a better experience, use the 'Export' feature.",
    'table_view': 'table',
    'tag_collar_as': 'tag collar as',
    'tag_collar_as_plural': 'tag collars as',
    'tank_analysis': 'tank analysis',
    'tank_analysis_abreviation': 'ta',
    'technology_by': 'technology by',
    'tecnical_review': 'technical review',
    'temperature': 'temperature',
    'temperature-humidity-index': 'temperature-humidity index',
    'temporary_suspension': 'temporary suspension',
    'term_no_results_found': 'your search for **{term}** returned no results. Try a different term.',
    'term_of_contract': 'term of the contract',
    'test_plural': 'tests',
    'thermal_comfort': 'thermal comfort',
    'thermal_comfort_and_rest': 'thermal comfort and rest',
    'thermal_stress': 'heat stress',
    'thi': 'THI',
    'THI_and_intake': 'THI and intake',
    'this_report_helps_our_team_fix_the_problem': 'this report helps our team fix the problem',
    'time_second': 'second',
    'time_second_plural': 'seconds',
    'timezone': 'timezone',
    'tip_from_female': '{item} tip',
    'title': 'title',
    'to_verify': 'verify',
    'token': 'token',
    'token_consumption': 'token consumption',
    'tokenizable_animals': 'tokenizable animals',
    'tokenized_animals': 'tokenized animals',
    'tokens': 'tokens',
    'tool_plural': 'tools',
    'topology': 'topology {item}',
    'total': 'total',
    'total_consumption': 'total consumption',
    'total_occurrences': 'total occurrences',
    'training_plural': 'training',
    'transacted_data': 'transacted data',
    'transaction_plural': 'transactions',
    'transactional_emails': 'transactional emails',
    'transfer_of_passive_immunity': 'transfer of passive immunity (TIP)',
    'transition': 'transition',
    'treated_cases': 'treated cases',
    'treated_male': 'treated',
    'treatment': 'treatment',
    'treatment_plural': 'treatments',
    'treatments': 'medications',
    'type': 'type',
    'type_description': 'type description',
    'type_to_find': 'type to start the search',
    'type_your_message_here': 'type your message here',
    'unanswered_companies': 'unanswered companies',
    'unanswered_farms': 'unanswered farms',
    'unarchive_item': 'unarchive {item}',
    'uncheck_all': 'uncheck all',
    'undo_discart': 'undo discard',
    'undo_removal': 'undo removal',
    'unit': 'unit {item}',
    'unit_plural': 'units',
    'unlinked_activity': 'unlinked activity',
    'unlinked_points': 'unlinked points',
    'unmark': 'unmark',
    'unmark_as_unfit': 'unmark as',
    'unmonitored_plural': 'unmonitored',
    'unprocessed': 'unprocessed',
    'unseen': 'unseen',
    'unsupported_image_format': 'unsupported image format, use: {formats}',
    'untag_collar': 'untag collar',
    'untag_collar_message': 'are you sure you want to remove the collar tag?',
    'untag_collar_message_plural': 'are you sure you want to remove the collar tags?',
    'untag_collar_plural': 'untag collars',
    'update_available': 'update available',
    'update_frequency': 'update frequency',
    'update_item': 'update {item}',
    'update_registration': 'registration update',
    'updated_at': 'Updated at',
    'updated_by': 'updated by',
    'upload_file_through_field_below': 'upload the file through the field below',
    'upload_image': 'upload image',
    'UPS_output': 'UPS output',
    'UPS_QoS': 'QoS UPS',
    'UPS_status': 'UPS (backup)',
    'upsell-churn': 'Upsell / Churn',
    'urea': 'urea',
    'urea_percentage': 'urea (%)',
    'use_history': 'use history',
    'used_treatment': 'treatment',
    'useful_links': 'useful links',
    'user': 'user',
    'user_environment': 'user environment',
    'user_informations': 'user informations',
    'user_name': 'username',
    'user_plural': 'users',
    'uses_location': 'uses location',
    'validated_at': 'validated at',
    'validity': 'validity',
    'value': 'value',
    'variability': 'variability',
    'variation_short': 'var.',
    'ventilation_system': 'Ventilation system',
    'version': 'version',
    'version_updated_at': 'the version was updated at',
    'VIC': 'VIC',
    'vic_ai_title': 'VIC AI',
    'vic_chat_audio_error_conversion_failed': 'Could not process the audio. Please record again',
    'vic_chat_audio_error_microphone_denied': 'Allow microphone access in your browser to record audio',
    'vic_chat_audio_error_microphone_unavailable': 'No microphone available to record audio',
    'vic_chat_audio_error_too_short': 'Audio too short. Please record again',
    'vic_chat_audio_limit_reached': 'Recording stopped: 1 minute limit reached',
    'vic_chat_audio_listening': 'VIC is listening to your audio',
    'vic_chat_audio_message': 'Audio message',
    'vic_chat_audio_recording': 'recording',
    'vic_chat_audio_stop': 'stop',
    'vic_chat_composer_placeholder': 'Type your message here',
    'vic_chat_composer_usage_limit_reached': 'VIC monthly limit reached. Resets on {date}',
    'vic_chat_conversations_empty': 'no chats',
    'vic_chat_conversations_favorites': 'favorites',
    'vic_chat_conversations_recent': 'recent',
    'vic_chat_delete_conversation_confirm_label': 'confirm deletion',
    'vic_chat_delete_conversation_label': 'delete conversation',
    'vic_chat_disclaimer': 'VIC can make mistakes. Check important information in the system.',
    'vic_chat_fab_label': 'open chat with VIC',
    'vic_chat_favorite_conversation_label': 'mark as favorite',
    'vic_chat_message_edit_label': 'edit message',
    'vic_chat_message_status_cancelled': 'cancelled',
    'vic_chat_message_status_error': 'error',
    'vic_chat_message_status_pending': 'pending',
    'vic_chat_message_status_read': 'read',
    'vic_chat_message_status_sending': 'sending',
    'vic_chat_message_status_sent': 'sent',
    'vic_chat_message_status_streaming': 'responding',
    'vic_chat_plan_limits_description': 'Your plan has a monthly token limit for chatting with VIC.',
    'vic_chat_plan_limits_monthly_usage': 'Farm usage',
    'vic_chat_plan_limits_remaining': '{percentage}% remaining',
    'vic_chat_plan_limits_resets_in': 'Resets on {date}',
    'vic_chat_plan_limits_total_usage': '{used} of {total} tokens',
    'vic_chat_plan_limits_user_usage': '{tokens} tokens · {percentage}% of the limit',
    'vic_chat_plan_limits_users_usage': 'Usage per user',
    'vic_chat_rename_conversation_label': 'rename conversation',
    'vic_chat_retry': 'try again',
    'vic_chat_settings_avatar_placement': 'VIC identification',
    'vic_chat_settings_avatar_placement_hidden': 'hidden',
    'vic_chat_settings_avatar_placement_inline': 'avatar next to the name',
    'vic_chat_settings_avatar_placement_name': 'name only',
    'vic_chat_settings_avatar_placement_side': 'avatar next to the message',
    'vic_chat_settings_display_description': 'Adjust the width, the font size and how VIC is identified in messages.',
    'vic_chat_settings_display_title': 'Display',
    'vic_chat_settings_drawer_width': 'Panel width',
    'vic_chat_settings_drawer_width_large': 'large',
    'vic_chat_settings_drawer_width_medium': 'medium',
    'vic_chat_settings_drawer_width_small': 'small',
    'vic_chat_settings_font_size': 'Font size',
    'vic_chat_settings_font_size_extra_large': 'extra large',
    'vic_chat_settings_font_size_extra_small': 'extra small',
    'vic_chat_settings_font_size_large': 'large',
    'vic_chat_settings_font_size_medium': 'medium',
    'vic_chat_settings_font_size_small': 'small',
    'vic_chat_settings_page_width': 'Conversation width',
    'vic_chat_settings_page_width_full': 'full',
    'vic_chat_settings_page_width_large': 'large',
    'vic_chat_settings_page_width_medium': 'medium',
    'vic_chat_settings_page_width_small': 'small',
    'vic_chat_stop_reply_label': 'stop response',
    'vic_chat_suggestion_alerts': 'Alerts',
    'vic_chat_suggestion_alerts_value': 'Which alerts are open on the farm today?',
    'vic_chat_suggestion_animals_batches': 'Animals and batches',
    'vic_chat_suggestion_animals_batches_value': 'How are my animals and batches doing?',
    'vic_chat_suggestion_help': 'Ask a question',
    'vic_chat_suggestion_help_value': 'How can VIC help me with the farm day to day?',
    'vic_chat_suggestion_routines': 'Routines',
    'vic_chat_suggestion_routines_value': 'Which routines do I have for today?',
    'vic_chat_token_usage_label': 'tokens used',
    'vic_chat_tool_approval_fallback': 'review the action before continuing',
    'vic_chat_tool_approved': 'you authorized this action',
    'vic_chat_tool_awaiting_confirmation': 'awaiting confirmation',
    'vic_chat_tool_denied': 'you refused this action',
    'vic_chat_tool_error': 'the action could not be completed',
    'vic_chat_tool_generic_title': 'VIC action',
    'vic_chat_tool_manage_animal_collars_title': 'link collars',
    'vic_chat_tool_running': 'running the action',
    'vic_chat_tool_success': 'action completed',
    'vic_chat_tool_unanswered': 'no answer',
    'vic_chat_unfavorite_conversation_label': 'remove from favorites',
    'vic_gpt_title': 'VIC GPT',
    'vic_routine_subtitle': 'Farm routines and protocols',
    'vic_usage_limit_placeholder': 'VIC usage limit reached this month',
    'vic_usage_limit_text': 'This farm has reached its VIC usage limit for the period. You will be able to chat again from {date}.',
    'vic_usage_limit_title': 'usage limit reached',
    'view': 'view',
    'view_all': 'view all',
    'view_all_count': 'view all {count}',
    'view_all_notifications': 'view all notifications',
    'view_all_tasks': 'view all tasks',
    'view_full_routine': 'view full routine',
    'view_history': 'view history',
    'view_item': 'view {item}',
    'view_score_chart': 'view score chart',
    'viewData': 'view data table',
    'visible_columns': 'visible columns',
    'visual_heat': 'visual heat',
    'voluntary_waiting_period_heats': 'heats VWP',
    'VWP_hint': 'fresh cows (VWP)',
    'waiting': 'waiting {item}',
    'waiting_conditions': 'Waiting for conditions...',
    'waiting_time': 'waiting time',
    'waiting-artificial-insemination': 'IR-FTAI',
    'waiting-embryo-transfer': 'IR-FTET',
    'weaning': 'weaning',
    'webleite': 'Web + Leite',
    'webleite_overview':
        'Web + Leite is a computerized control and management system for dairy farming, used by breeders\' associations. Once the producer has access, they can integrate it with CowMed.\n\n### How it works\n\n1. Access Web + Leite to generate a new token.\n2. In the **Integrações** menu, open the **Autenticadores** option.\n3. Click the **"+"** button to create a new access, naming it CowMed.\n4. Web + Leite will generate a token, a long sequence of letters and numbers. Copy this token.\n5. Here in CowMed, click **Connect** and follow the setup steps using the token copied from Web + Leite.\n\n### Available data\n\n- Bulk tank analysis (read)\n- Individual milk recording (read)',
    'weekdays_friday': 'friday',
    'weekdays_monday': 'monday',
    'weekdays_saturday': 'saturday',
    'weekdays_sunday': 'sunday',
    'weekdays_thursday': 'thursday',
    'weekdays_tuesday': 'tuesday',
    'weekdays_wednesday': 'wednesday',
    'weight': 'weight',
    'welcome': 'welcome',
    'what_are_you_looking_for': 'what are you looking for?',
    'what_do_you_want_to_register': 'what do you want to register?',
    'with_attach': 'linked',
    'with_diagnosis': 'with diagnosis',
    'with_withdrawal_period': 'with withdrawal period',
    'without_diagnosis': 'without diagnosis',
    'without_diagnostic_text': 'No diagnoses reported in the last {item} days.',
    'without_information': 'without information',
    'without_leading_zeros': 'without leading zeros',
    'without_withdrawal_period': 'without withdrawal period',
    'write_message': 'write your message',
    'year': 'year',
    'yes': 'yes',
    'your_software_was_updated': 'your software has new updates',
    'zip_code': 'zip code',
} as const

export { en }
